import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyLifeActsBlocksComponent } from './myLifeActsBlocks.component';
import { BlockButtonModule } from '@app/components/blocks/block-button/block-button.module';
import { ReactiveFormsModule } from '@angular/forms';
import { LoaderModule } from '@shared/loader/loader.module';
import { BlockLifeactModule } from '@app/components/blocks/block-lifeact/block-lifeact.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [MyLifeActsBlocksComponent],
  exports: [MyLifeActsBlocksComponent],
  imports: [CommonModule, BlockButtonModule, ReactiveFormsModule, LoaderModule, BlockLifeactModule, TranslateModule],
})
export class MyLifeActsBlocksModule {}
